import React from 'react';

export default [
  {
    key: 'docking_process',
    tab: (
      <span>对接流程</span>
    )
  },
  {
    key: 'docs',
    tab: (
      <span>API文档</span>
    )
  },
  {
    key: 'common_tools',
    tab: (
      <span>常用工具</span>
    )
  },
  {
    key: 'security_guard',
    tab: (
      <span>安全保障</span>
    )
  },
];
